<div class="mon-dialog-header">
  <mon-page-header header="{{ getStepTitle() }}"></mon-page-header>
</div>

<div class="mon-dialog-body-with-footer">
  @if (currentStep === 'mapping') {
    <app-upload-mapping
      (complete)="onMappingComplete($event)">
    </app-upload-mapping>
  }

  @if (currentStep === 'validation') {
    <app-upload-validation
      [data]="parsedData"
      (complete)="onValidationComplete($event)">
    </app-upload-validation>
  }

  @if (currentStep === 'progress') {
    <app-upload-progress
      [data]="validatedData"
      (complete)="onProgressComplete($event)">
    </app-upload-progress>
  }

  @if (currentStep === 'results') {
    <app-upload-results
      [result]="importResult">
    </app-upload-results>
  }
</div>

<div class="mon-dialog-footer d-flex justify-content-between">
  <div>
    @if (currentStep === 'validation') {
      <button type="button" class="btn btn-outline-secondary" (click)="onBack('mapping')">
        Back
      </button>
    }
  </div>
  
  <div>
    @if (currentStep === 'mapping') {
      <button type="button" class="btn btn-primary me-2" [disabled]="!canProceedFromMapping()" (click)="proceedFromMapping()">
        Next: Validate Data
      </button>
      <button type="button" class="btn btn-secondary" (click)="cancelDialog()">
        Cancel
      </button>
    }
    @if (currentStep === 'validation') {
      <button type="button" class="btn btn-primary me-2" [disabled]="!canProceedFromValidation()" (click)="proceedFromValidation()">
        Import {{ getValidRowCount() }} Check{{ getValidRowCount() === 1 ? '' : 's' }}
      </button>
      <button type="button" class="btn btn-secondary" (click)="cancelDialog()">
        Cancel
      </button>
    }
    @if (currentStep === 'results') {
      <button type="button" class="btn btn-primary" (click)="close()">
        Close
      </button>
    }
  </div>
</div>
